// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import FormController from './form_controller';
import Events from '../classes/Events';
import axios from 'axios';

class SignupForm extends FormController {
  static targets = [
    'email',
    'password',
    'errorMessage'
  ]

  targetNames() {
    return SignupForm.targets;
  }

  async createUser() {
    try {
      await axios.post('/users/sign_up/', {
        email: this.emailTarget.value,
        password: this.passwordTarget.value,
      })
      this.element.dispatchEvent(Events.submittedEvent);
    } catch(e) {
      this.element.dispatchEvent(Events.errorEvent)
    }
  }

  showError() {
    this.errorMessageTarget.textContent = "Looks like we're missing some information.";
    this.errorMessageTarget.classList.remove('t-hidden');
  }

  connect() {
    super.connect();
  }
}

export default SignupForm;
